// Module
var code = "<?xml version=\"1.0\" encoding=\"utf-8\"?> <svg viewBox=\"0 0 512 512\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M184.49 79.0307L361.46 256.001L184.49 432.971L150.54 399.031L293.57 256.001L150.54 112.971L184.49 79.0307Z\"/> </svg> ";
// Exports
module.exports = code;